import { render, staticRenderFns } from "./SystemUnderMaintenance.vue?vue&type=template&id=048561ea&scoped=true&"
import script from "./SystemUnderMaintenance.vue?vue&type=script&lang=js&"
export * from "./SystemUnderMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./SystemUnderMaintenance.vue?vue&type=style&index=0&id=048561ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048561ea",
  null
  
)

export default component.exports